import script from "./UChoosePhotoType.vue?vue&type=script&setup=true&lang=ts"
export * from "./UChoosePhotoType.vue?vue&type=script&setup=true&lang=ts"

import "./UChoosePhotoType.vue?vue&type=style&index=0&id=8138b4b2&lang=css"

const __exports__ = script;

export default __exports__